/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Pagecrashedmessage2Inputs */

const en_errors_pagecrashedmessage2 = /** @type {(inputs: Errors_Pagecrashedmessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. We've been notified and will start working on a fix. Please refresh or try to access the page later. If it keeps persisting, please reach out to `)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred. We've been notified and will start working on a fix. Please refresh or try to access the page later. If it keeps persisting, pl..." |
*
* @param {Errors_Pagecrashedmessage2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_pagecrashedmessage2 = /** @type {((inputs?: Errors_Pagecrashedmessage2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Pagecrashedmessage2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_pagecrashedmessage2(inputs)
});
export { errors_pagecrashedmessage2 as "errors_pageCrashedMessage" }